export class MeasurementHelper {
    private readonly METERS_PER_INCH = 0.0254;
    private readonly LBS_PER_KG = 2.20462262;

    private isValidNumber(value: unknown): value is number {
        return typeof value === 'number' && !Number.isNaN(value);
    }

    public metersToInches(meters: number): number {
        if (!this.isValidNumber(meters)) return 0;
        return Math.round((meters / this.METERS_PER_INCH) * 100) / 100;
    }

    public inchesToMeters(inches: number): number {
        if (!this.isValidNumber(inches)) return 0;
        return Math.round((inches * this.METERS_PER_INCH) * 100) / 100;
    }

    public feetAndInchesToTotalInches(feet: number, inches: number): number {
        const safeFeet = this.isValidNumber(feet) ? feet : 0;
        const safeInches = this.isValidNumber(inches) ? inches : 0;
        return (safeFeet * 12) + safeInches;
    }

    public kgToLbs(kg: number): number {
        if (!this.isValidNumber(kg)) return 0;
        return Math.round(kg * this.LBS_PER_KG);
    }

    public lbsToKg(lbs: number): number {
        if (!this.isValidNumber(lbs)) return 0;
        return Math.round((lbs / this.LBS_PER_KG) * 100) / 100;
    }
}